import TreeIcon from "~icons/local/tree";
import { Link, useParams } from "react-router";
import { getUrl } from "../useToPage";
import usePage from "../usePage";
import { Page } from "@/types";

export default function Overview() {
  const { teamSlug, rfqId } = useParams();
  const page = usePage();
  return (
    <Link
      to={getUrl("rfq", { teamSlug: teamSlug!, rfqId: rfqId! })}
      className={`flex items-center gap-2 hover:bg-blue-100 p-1 ${[Page.rfq].includes(page!) ? "bg-blue-200" : ""} rounded-sm`}
    >
      <TreeIcon />
      Overview
    </Link>
  );
}
